import { type LDFlagSet, type LDContext, LDProvider } from 'launchdarkly-react-client-sdk'
import { logError } from 'lib/tracking/datadog'
import { logNonExistentFlags } from 'routes/components/AppPage/components/FeatureFlagsProvider/helpers/logNonExistentFlags/logNonExistentFlags'
import { flags } from './FeatureFlagsProvider.consts'
import { GlobalLDFlagsGetter } from './hooks/useGlobalLDFlagsGetter/useGlobalLDFlagsGetter'

const clientSideID = process.env.LAUNCHDARKLY_ID

export interface FeatureFlagsProviderProps {
  context?: LDContext | undefined
  bootstrap?: LDFlagSet | undefined
}

export const FeatureFlagsProvider: Settle.FC<FeatureFlagsProviderProps> = ({ children, context, bootstrap }) => {
  if (!clientSideID) {
    logError(new Error('LAUNCHDARKLY_ID is not set'))
    return children
  }

  return (
    <LDProvider
      flags={flags}
      context={context}
      clientSideID={clientSideID}
      options={{
        bootstrap,
        inspectors: [{ type: 'flag-details-changed', name: 'log-non-existent-flags', method: logNonExistentFlags }],
      }}
    >
      {children}
      <GlobalLDFlagsGetter />
    </LDProvider>
  )
}
